import Indicador from "..";
import { PDTParamFields } from "./components/ParamFields";
import pdtReport from "./reports";
import pdtReportSummary from "./reports/summary";
import PDTEditFields from "./components/EditFields";

export default class PDT extends Indicador {
    static get fullName() {
        return "Profundidade Distribuição de Torta";
    }

    static get abbrev() {
        return "PDT";
    }

    static get legacyApontamentoMap() {
        return {
            // Data/Hora de PDT está realmente como 'dataHoraNGV' no banco.
            dataHora: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            tipo: "tipo",
            talhao: "talhao",
            trator: "trator",
            implemento: "implemento",
            frente: "frente",
            turno: "turno",

            coletas: {
                type: Array,
                newField: "coletas",
                children: {
                    profundidadeColeta: "profundidade",
                    conforme: "conforme",
                    observacao: "observacao",
                    foto: {
                        newField: "image.uid",
                        convert: this.convertLegacyImageUid,
                    },
                    confirmaRelatorio: "confirmaRelatorio",
                    "foto.georeferencia": "georeferencia",
                    georeferencia: "georeferencia",
                },
            },

            conformidadeAmostra: "conformidade",

            observacaoAmostra: "observacao",

            itensColeta: "images",
        };
    }

    static get legacyParamMap() {
        return {
            pdTintervaloAderenciaMinimoManual: "manual.intervaloMin",
            pdTintervaloAderenciaMaximoManual: "manual.intervaloMax",
            pdTvalorMetaManual: "manual.meta",

            pdTintervaloAderenciaMinimoMecanizado: "mecanizado.intervaloMin",
            pdTintervaloAderenciaMaximoMecanizado: "mecanizado.intervaloMax",
            pdTvalorMetaMecanizado: "mecanizado.meta",

            pontosAmostradosPDT: {
                type: Array,
                newField: "items",
                paramMap: {
                    classificacaoPDTpontosAmostrados: "classificacao",
                    intervalo1PDTpontosAmostrados: "intervaloMin",
                    intervalo2PDTpontosAmostrados: "intervaloMax",
                    sinalIntervaloMin: "sinalIntervaloMin",
                    sinalIntervaloMax: "sinalIntervaloMax",
                },
            },
        };
    }

    static paramFields(tipoIndicadorField = '') {
        return <PDTParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <PDTEditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return pdtReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return pdtReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        let conformeCount = 0;
        const total = apontamento.coletas.length;

        for (const coleta of apontamento.coletas) {
            if (f(coleta.profundidade) >= f(params.intervaloMin) && f(coleta.profundidade) <= f(params.intervaloMax)) {
                coleta.conforme = "Sim";
                coleta.acima = 0
                coleta.abaixo = 0
                conformeCount++;
            } else {
                coleta.conforme = "Não";
                if (f(coleta.profundidade) > f(params.intervaloMax)) {
                    coleta.acima = 1
                    coleta.abaixo = 0
                } else {
                    coleta.acima = 0
                    coleta.abaixo = 1
                }
            }
        }

        return ((100 * conformeCount) / total).toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatus(conformidade, meta, 90, 94.45, 100);
    }

    static calcPontosAmostrados(apontamento, paramItems) {
        const result = [];

        for (const item of paramItems) {
            let count = 0;

            for (const coleta of apontamento.coletas) {
                if (this.calcPontoAmostradoColeta(item, coleta.profundidade)) {
                    count++;
                }
            }

            result.push({
                ...item,
                count: count,
            });
        }

        return result;
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            {
                title: "Operador", width: 'auto', getValue: (a) => {
                    if (a.operador && a.operador.operador) return a.operador.operador
                    if (typeof a.operador === "string" && a.operador) return a.operador
                    return "-"
                }
            },

            { title: "Implemento", field: "implemento.nomeImplemento", width: 'auto' },

            {
                title: "Conf.(%)", field: "conformidade", width: 38, getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },
        ]
    }

    static getResultStr(apontamento) {
        return ""
    }
}
